import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ColorModeIconDropdown from '../../shared-theme/ColorModeIconDropdown';

export default function Hero() {
  return (
    <Box
      id="hero"
      sx={(theme) => ({
        width: '100%',
        backgroundRepeat: 'no-repeat',

        backgroundImage:
          'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)',
        ...theme.applyStyles('dark', {
          backgroundImage:
            'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 16%), transparent)',
        }),
      })}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'flex-end',
          padding: 1,
        }}
      >            
        <ColorModeIconDropdown />
      </Box>   
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 2, sm: 3 },
          pb: { xs: 2, sm: 3 },
        }}
      >
              
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={4}
          useFlexGap
          sx={{
            alignItems: 'center', // Center items vertically in both column and row
            width: '100%',
            justifyContent: { sm: 'center' },
            minHeight: { sm: 350 }, // Optional: ensures enough height for vertical centering
          }}
        >
          <Box
            component="img"
            src="/logo.png"
            alt="Cowern Construction logo"
            sx={{
              width: { xs: '100%', sm: 300 },
              maxWidth: '100%',
              borderRadius: 2,
              objectFit: 'contain',
              alignSelf: 'center', // Center image vertically in Stack
            }}
          />
          <Stack
            spacing={2}
            useFlexGap
            sx={{
              alignItems: { xs: 'center', sm: 'flex-start' },
              width: { xs: '100%', sm: 'auto' },
              flex: 1,
              justifyContent: 'center', // Center content vertically in inner Stack
              height: '100%',
            }}
          >
            <Box sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
              <Typography variant="h6" sx={{ mb: 0.5 }}>
                <strong>Email:</strong>{' '}
                <a href="mailto:construction@cowern.co.uk" style={{ color: 'inherit', textDecoration: 'underline', fontSize: 'inherit' }}>
                  construction@cowern.co.uk
                </a>
              </Typography>
              <Typography variant="h6">
                <strong>Mobile:</strong>{' '}
                <a href="tel:07561892629" style={{ color: 'inherit', textDecoration: 'underline', fontSize: 'inherit' }}>
                  07561 892629
                </a>
              </Typography>
            </Box>
            <Typography
              sx={{
                textAlign: { xs: 'center', sm: 'left' },
                color: 'text.secondary',
                width: { sm: '100%', md: '80%' },
              }}
            >
              Building your future with care and craftsmanship. As a family-run business, we’re committed to providing quality construction services tailored to your needs—with reliability, integrity, and a personal touch every step of the way.
            </Typography>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
